import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';

export class CuratedFiltersFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    tooltip: string;
    emptyMessage: string;
    overflowMessage: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        tooltip: string = 'Core.button.filter',
        emptyMessage: string = 'Common.filter.emptyMessage',
        overflowMessage: string = 'Common.filter.overflowMessage'
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.tooltip = tooltip;
        this.emptyMessage = emptyMessage;
        this.overflowMessage = overflowMessage;
    }
}
